import { GridCellProps } from '@progress/kendo-react-grid';
import { isNumber, isUndefined } from 'lodash';
import { FC, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';

const ReceiptPercentage: FC<GridCellProps> = (props) => {
  const { dataItem } = props;
  const value = useMemo(
    () =>
      !isNumber(Number(dataItem.quantityReceived)) ||
      !isNumber(Number(dataItem.receivedQty)) ||
      !dataItem.receivedQty ||
      Number(dataItem.receivedQty) === 0 ||
      isUndefined(dataItem.quantityReceived) ||
      Number(dataItem.poQty) === 0
        ? 'N/A'
        : `${Math.round(
            (Number(dataItem.quantityReceived) / Number(dataItem.receivedQty)) * 100
          )}%`,
    [dataItem.poQty, dataItem.quantityReceived, dataItem.receivedQty]
  );

  return (
    <GridCellBase {...props} title={value}>
      {value}
    </GridCellBase>
  );
};

export default ReceiptPercentage;
